<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

  <div class="card p-3">
    <h5 class="mb-3">Calculadora de IMC</h5>

    <div class="row mb-3">
      <div class="col-6">
        <label class="form-label">Peso (kg)</label>
        <input
          type="number"
          class="form-control"
          v-model.number="peso"
          min="1"
        />
      </div>

      <div class="col-6">
        <label class="form-label">Talla (cm)</label>
        <input
          type="number"
          class="form-control"
          v-model.number="talla"
          min="30"
        />
      </div>
    </div>

    <button class="btn btn-primary" @click="calcularIMC">
      Calcular
    </button>

    <div v-if="imc" class="mt-3">
      <h6>Resultado</h6>
      <p>
        <strong>IMC:</strong> {{ imc }}
      </p>

      <span class="badge" :class="badgeClase">
        {{ clasificacion }}
      </span>

      <p class="text-muted mt-2">
        El IMC es una referencia general. En niños y adolescentes debe evaluarse
        junto con edad y sexo.
      </p>
    </div>
  </div>

    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'CalculadoraIMC',
  components: {
    Layout, Footer
  },
  
  data() {
    return {
      peso: null,
      talla: null,
      imc: null,
      clasificacion: ''
    }
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  
  methods: {
    calcularIMC() {
      if (!this.peso || !this.talla) {
        return
      }

      const tallaMetros = this.talla / 100
      const resultado = this.peso / (tallaMetros * tallaMetros)

      this.imc = resultado.toFixed(2)
      this.clasificarIMC(resultado)
    },

    clasificarIMC(valor) {
      if (valor < 18.5) {
        this.clasificacion = 'Bajo peso'
      } else if (valor < 25) {
        this.clasificacion = 'Peso normal'
      } else if (valor < 30) {
        this.clasificacion = 'Sobrepeso'
      } else {
        this.clasificacion = 'Obesidad'
      }
    }
  },

  computed: {
    badgeClase() {
      if (!this.imc) return ''
      if (this.imc < 18.5) return 'bg-info'
      if (this.imc < 25) return 'bg-success'
      if (this.imc < 30) return 'bg-warning'
      return 'bg-danger'
    }
  }
  
}
</script>